var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotificationBell({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.82951 8.93745C4.82837 8.12208 4.98862 7.31455 5.30103 6.5614C5.61344 5.80826 6.07182 5.1244 6.64976 4.54923C7.2277 3.97407 7.91376 3.51898 8.6684 3.2102C9.42304 2.90142 10.2313 2.74506 11.0467 2.75012C14.4489 2.77541 17.1703 5.60336 17.1703 9.01512V9.62495C17.1703 12.7029 17.8142 14.4889 18.3814 15.4651C18.4425 15.5694 18.475 15.688 18.4757 15.8089C18.4763 15.9297 18.4451 16.0487 18.3851 16.1536C18.3251 16.2586 18.2385 16.3458 18.134 16.4066C18.0296 16.4675 17.9109 16.4996 17.79 16.4999H4.20909C4.08819 16.4996 3.96952 16.4674 3.86503 16.4066C3.76055 16.3458 3.67395 16.2585 3.61398 16.1535C3.55401 16.0486 3.52278 15.9296 3.52345 15.8087C3.52412 15.6878 3.55666 15.5693 3.61778 15.4649C4.18525 14.4887 4.8295 12.7027 4.8295 9.62495L4.82951 8.93745Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 16.5V17.1875C8.25 17.9168 8.53973 18.6163 9.05546 19.132C9.57118 19.6478 10.2707 19.9375 11 19.9375C11.7293 19.9375 12.4288 19.6478 12.9445 19.132C13.4603 18.6163 13.75 17.9168 13.75 17.1875V16.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notification_bell.d60554f0.svg";
export { ForwardRef as ReactComponent };